<template>
  <Teleport defer to="#portal_popup"> 
    <modal-window :modal_open="true" title="Create Financial Category" @close="$emit('close')">
      <div class="text-green-600 flex flex-col justify-around font-medium text-base">
        * Required Fields
      </div>
      <div class="grid grid-cols-2 mt-5 gap-3">
        <div class="w-full col-span-2">
          <div class="font-medium">Description <span class="text-green-600">*</span></div>
          <input v-model="financialCateogry.description" type="text" class="form-control">
        </div>
        <div class="w-full">
          <div class="font-medium">Mark Up <span class="text-green-600">*</span></div>
          <input v-model.number="financialCateogry.markup" type="number" class="form-control">
        </div>
        <div class="w-full cols-span-2">
          <div class="font-medium">Wastage <span class="text-green-600">*</span></div>
          <input v-model.number="financialCateogry.wastage" type="number" class="form-control">
        </div>
        <div class="w-full flex flex-col gap-3 cols-span-2">
          <div class="font-medium">No Mark Up To Price</div>
          <div
            :class="{ 'pointer-events-none opacity-50': demo_mode }"
            class="relative cursor-pointer"
            @click.stop="financialCateogry.noMarkupToPrice = !financialCateogry.noMarkupToPrice"
          >
            <div class="w-6 h-3 bg-gray-400 rounded-full shadow-inner" />
            <div class="switch-toggle" :class="{ _active: financialCateogry.noMarkupToPrice }" />
          </div>
        </div>
      </div>
      <div class="text-right mt-4 xs:mt-8 flex flex-col 2xs:block">
        <button class="btn btn-lg 2xs:mr-1 mb-1 2xs:mb-0" @click.prevent="$emit('close')">
          Cancel
        </button>
        <button class="btn btn-action btn-lg" @click.prevent.stop="add">Add Category</button>
      </div>
    </modal-window>
  </Teleport>
</template>

<script>

import validate from 'validate.js';

export default {
  data() {
    return {
      financialCateogry: {
        description: '',
        markup: 0,
        wastage: 0,
        noMarkupToPrice: false,
        listIndex: -1
      }
    };
  },
  methods: {
    async add() {
      const validationErrors = validate(
        {
          description: this.financialCateogry.description,
          markup: this.financialCateogry.markup,
          wastage: this.financialCateogry.wastage,
        },
        {
          description: {
            presence: { allowEmpty: false },
            length: {
              maximum: 255,
            },
          },
          markup: {
            presence: { allowEmpty: false },
          },
          wastage: {
            presence: { allowEmpty: false },
          },
        },
      );

      if (validationErrors) {
        this.alertBox().fire({
          title: 'Errors',
          icon: 'error',
          html: `<ul>${Object.values(validationErrors).join('</li><li>')}</ul>`,
        });
        return;
      }

      this.$emit('addCategory', this.financialCateogry)
    },
  },
};
</script>
